import * as React from "react";
import {Button, TextField, useTheme} from "@mui/material";
import {useState} from "react";
import Box from "@mui/material/Box";
import {useNotify} from "../../../domains/common/components/AlertNotify";
import axios from "axios";
import {getBackendURL} from "../../../fn";
import {ButtonBase} from "../../../domains/common/components/Button";
import {dealData} from "../deal";

export const maxCommentLength = 300;

/**
 * @returns {Element}
 * @constructor
 */
export default function DealCommentContainer() {
  const [symbols, setSymbols] = useState(dealData.deal.comment?.length || 0);
  const [state, setState] = useState(dealData.deal.comment);

  const {openNotify} = useNotify();
  const theme = useTheme();

  const save = async () => {
    return await new Promise(() => {
      axios.post(`${getBackendURL()}/deal/${dealData.deal.id}/comment`, {comment: state},{
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      }).then(() => {
        openNotify({
          msg: "Комментарий сохранен успешно",
          duration: 2000,
          type: 'success',
          positionH: 'right',
        })
      }).catch(() => {
        openNotify({
          msg: "При сохранении возникла ошибка",
          duration: 5000,
          type: 'error',
          positionH: 'right',
        })
      });
    });
  }

  const onChange = (event) => {
    setSymbols(event.target.value.length);
    setState(event.target.value)
  }

  return (
    <>
      <p/>
        <TextField
          defaultValue={state}
          helperText={`${symbols}/${maxCommentLength}`}
          variant="outlined"
          label="Комментарий для Росреестра"
          onChange={onChange}
          multiline
          size="sm"
          rows={4}
          inputProps={{ maxLength: maxCommentLength }}
          sx={{width: '500px', zIndex: 0}}
        />
        <Box display="flex" justifyContent="flex-end">
          <ButtonBase variant="contained" size="small" onClick={save} sx={{color: theme.palette.text.default}}>Сохранить</ButtonBase>
        </Box>
      </>
  )
}